import React, { useState } from "react";
import { useDispatch } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { ACL_UNBLOCK_USER_URL } from "../../config";
import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";
import {
    showSuccessAlert,
    showErrorAlert
} from "../../store/actions/alerts";

import makeApiRequest from "../../utils/axios/new-axios";
import history from "../../store/history";

export default function UnblockUserForm({
    openModal,
    handleCloseModal,
    userId
}) {

    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    async function handleSubmit() {
        setIsSubmitting(true);

        await makeApiRequest({
            url: `${ACL_UNBLOCK_USER_URL.url}/${userId}`,
            method: ACL_UNBLOCK_USER_URL.method
        }).then(response => {
            dispatch(showSuccessAlert(`Unblocked User Successfully!`));
            history.push(`/acl/users`);
        }).catch(error => {
            dispatch(
                showErrorAlert(
                    "Error : " +
                    (!!error.response
                        ? `${error.response.status}! - ${error.response.data.errorMessage}`
                        : error.message)
                )
            );
        });

        setIsSubmitting(false);
    }

    return (
        <Dialog
            open={openModal}
            onClose={handleCloseModal}
            fullWidth={true}
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
        >
            <DialogTitle id="alert-dialog-title">Un-Block User</DialogTitle>
            <DialogContent dividers>
                <p>
                    This process is irreversible. User will have access to the website once their account is un-blocked
                </p>
            </DialogContent>
            <DialogActions style={{ margin: "20px" }}>
                <CancelButton
                    onClick={handleCloseModal}
                    disabled={isSubmitting}
                >
                    Cancel
                </CancelButton>
                <SubmitButton
                    disabled={isSubmitting}
                    isSubmitting={isSubmitting}
                    onClick={handleSubmit}
                >
                    Un-Block
                </SubmitButton>
            </DialogActions>
        </Dialog>
    )
}
